import { Drawer } from 'antd';
import BoxContainer from '../BoxContainer';
import FilterContainer from '../FilterContainer';
import Title from '../BoxContainer/components/Title';
import { TRIGGER_COLUMNS } from './constants';
import { ResponsiveTable } from '../Table';

export const TriggersDrawer = ({ open, onClose, title, dataSource, drawerProps }) => {
  return (
    <Drawer destroyOnClose closable={false} footer={null} open={open} {...drawerProps}>
      <BoxContainer>
        <BoxContainer content bottomBorder fixed>
          <FilterContainer goBack={onClose} title={<Title.Header value={title} />} />
        </BoxContainer>
        <BoxContainer content>
          <div className="gx-pt-4">
            <ResponsiveTable dataSource={dataSource} columns={TRIGGER_COLUMNS} />
          </div>
        </BoxContainer>
      </BoxContainer>
    </Drawer>
  );
};
